import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import Configuration from './pages/Configuration';
import ConfigurationDetail from './pages/ConfigurationDetail';
import Constants from "./flux/Constants";

class App extends Component {



  render() {
    if(Constants.ENV !== 'local'){
      Bugsnag.start({
        apiKey: Constants.BUGSNAG_API_KEY,
        releaseStage: Constants.BUGSNAG_RELEASE_STAGE,
        plugins: [new BugsnagPluginReact()],
      });
      var ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
      return (
        <ErrorBoundary>
          <Router>
            <Switch>
              <Route exact path="/detail/:code" component={ConfigurationDetail} />
              <Route exact path="/" component={Configuration} />
              <Redirect to="/" />
            </Switch>
          </Router>
        </ErrorBoundary>
      );
    }else{
      return (
          <Router>
            <Switch>
              <Route exact path="/detail/:code" component={ConfigurationDetail} />
              <Route exact path="/" component={Configuration} />
              <Redirect to="/" />
            </Switch>
          </Router>
      );
    }


  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js